import React from "react";
import { Helmet } from "react-helmet";
import Header from "../../components/header"; // Assuming you have a Header component
import HeroContent from "../../components/HeroContent";
import BlogSection from "../../components/BlogSection";
import logo from "../../assets/logo.svg";
import ConversationSection from "../../components/ConversationSection";
import Footer from "../../components/Footer";
import "./home.css";

const Home = () => {
  return (
    <div className="home-page">
      <Helmet>
        <title>Thought Box</title>
        <meta
          name="description"
          content="ThoughtBox is a space for curious minds to explore, learn, and share ideas. It bridges the known and the unknown, encouraging conversations across diverse perspectives."
        />
        <meta property="og:title" content="ThoughtBox" />
        <meta
          property="og:description"
          content="ThoughtBox is a space for curious minds to explore, learn, and share ideas. It bridges the known and the unknown, encouraging conversations across diverse perspectives."
        />
        <meta property="og:image" content={logo} />
        <meta property="og:url" content="https://thought-box.in/" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="ThoughtBox" />
        <meta
          name="twitter:description"
          content="ThoughtBox is a space for curious minds to explore, learn, and share ideas. It bridges the known and the unknown, encouraging conversations across diverse perspectives."
        />
        <meta name="twitter:image" content={logo} />
      </Helmet>
      <Header />
      <HeroContent />
      <BlogSection />
      <ConversationSection />
      <Footer />
      {/* Add other sections of your home page here */}
    </div>
  );
};

export default Home;
